import constantFactory from "@gaoding/constant-factory";

export const { SEX, SEX_LIST, SEX_MAP, SEX_ITEM_MAP } = constantFactory("SEX", [
  {
    key: "SECRECY",
    label: "保密",
    value: 0,
  },
  {
    key: "MALE",
    label: "男",
    value: 1,
  },
  {
    key: "FEMALE",
    label: "女",
    value: 2,
  },
]);
